import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { PromosScreen } from "../components/promos/PromosScreen";

export const Route = createFileRoute("/_auth/promos")({
  staticData: { titleKey: "nav.promos", breadcrumbKey: "breadcrumb.operate", breadcrumbN: 7 },
  // The promo whose detail is open.
  validateSearch: z.object({ promo: z.string().optional() }),
  component: PromosScreen,
});
